import React, { forwardRef, useImperativeHandle } from 'react';
import { cn } from '../../lib/utils';

export interface StarIconHandle {
  startAnimation: () => void;
  stopAnimation: () => void;
}

export interface StarIconProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
  color?: string;
  fill?: string;
}

export const StarIcon = forwardRef<StarIconHandle, StarIconProps>(
  ({ className, size = 16, color = 'currentColor', fill = 'currentColor', style, ...props }, ref) => {
    useImperativeHandle(ref, () => ({
      startAnimation: () => {},
      stopAnimation: () => {},
    }));

    return (
      <div
        className={cn(
          'inline-flex items-center justify-center select-none',
          className
        )}
        style={{ width: size, height: size, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', ...style }}
        {...props}
      >
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill={fill}
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      </div>
    );
  }
);

StarIcon.displayName = 'StarIcon';
